"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  workflowCommon: {
    flowManagement: 'Flow Management',
    instanceManagement: 'Instance Management',
    instanceDetail: 'Instance Detail',
    flowInfo: 'Flow Info',
    search: 'Search',
    reset: 'Reset',
    createTime: 'Create Time'
  },
  workflowControl: {
    tab: {
      instanceSingleNumber: 'Instance Single Number',
      flowName: 'Flow Name',
      flowStatus: 'Flow Status',
      appName: 'AppName',
      creator: 'Creator',
      createTime: 'Release Time',
      beforeLink: 'Before Link',
      beforeLinkTime: 'Before Link Time Consuming',
      currentLink: 'Current Link',
      currentLinkTime: 'Current Link Time Consuming',
      operator: 'Operator'
    },
    statusType: {
      running: 'Running',
      hang: 'Hang',
      finish: 'Finish',
      termination: 'Termination',
      exception: 'Exception'
    }
  }
};